const initialState = {
    local: {
        favourites: {},
        exOut: {},
    },
    app: {},
};

export default initialState;
